import PrefixEnum from '../prefixes'

export default Object.freeze({
    'machdichleicht.de': PrefixEnum.URSULA,
    'www.machdichleicht.de': PrefixEnum.URSULA,
})
